import React from 'react';

import currencyFormat from 'components/Widgets/currencyFormat';
import ExternalLink from 'components/Widgets/ExternalLink';

export default [
  {
    name: 'Date',
    selector: (row) => row.attributes.invoice_date_formatted,
    sortable: true,
  },
  {
    name: 'Due Date',
    selector: (row) => row.attributes.due_date_formatted,
    sortable: true,
  },
  {
    name: 'Days Late',
    selector: (row) => row.attributes.days_late,
    sortable: true,
  },
  {
    name: 'Invoice Number',
    selector: (row) => row.attributes.invoice_number,
    cell: (row) => (
      <ExternalLink
        href={row.attributes.invoice_link}
        variant={null}
      >
        {row.attributes.invoice_number}
      </ExternalLink>
    ),
    sortable: true,
  },
  {
    name: 'Payment Method',
    selector: (row) => row.attributes.payment_method,
    sortable: true,
  },
  {
    name: 'Status',
    selector: (row) => row.attributes.status,
    cell: (row) => <span className="text-capitalize">{row.attributes.status}</span>,
    sortable: true,
  },
  {
    name: 'Amount',
    selector: (row) => Number(row.attributes.amount),
    cell: (row) => currencyFormat(row.attributes.amount, { currency: row.attributes.currency.title }),
    sortable: true,
  },
];
